import { z } from 'zod/v4';

export const apiKeySummarySchema = z.object({
  id: z.number().min(1),
  key: z.string().min(1),
  description: z.string(),
  expirationDate: z.string().nullable(),
  applications: z.array(z.string().min(1)),
});

export type ApiKeySummary = z.infer<typeof apiKeySummarySchema>;
